module.exports = __webpack_public_path__ + "img/F3M8_new.56c2b324.jpg";